module.exports = __webpack_public_path__ + "static/img/footbar.64eda5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footbar.png
// module id = 6Oco
// module chunks = 6